"use client";

import { PlainMessage } from "@bufbuild/protobuf";
import { LocalTime } from "@egocentric-systems/ts-apis/types/v1/localtime_pb";
import { ReactNode } from "react";
import { useSale } from "~/hooks/useSale";
import { useTranslations } from "~/hooks/useTranslations";

type Props = {
  soldOut: boolean;
  saleStart: PlainMessage<LocalTime> | undefined;
  saleEnd: PlainMessage<LocalTime> | undefined;
};

export function Timer(props: Props): ReactNode {
  const t = useTranslations();
  const { remainingTime } = useSale({
    soldOut: props.soldOut,
    saleStart: props.saleStart,
    saleEnd: props.saleEnd,
  });

  return (
    <span>
      {t.presale}
      {" in "}
      {remainingTime}
    </span>
  );
}
